import { ComponentProps } from "react";
import { createTheme } from "flowbite-react";

const h5Theme = createTheme({
  h5: {
    base: "text-lg font-semibold",
    colors: {
      base: "text-foreground",
      primary: "text-primary",
      success: "text-success",
      warning: "text-warning",
      error: "text-error",
    },
  },
}).h5;

type H5Props = {
  children: React.ReactNode
  color?: keyof typeof h5Theme.colors
  className?: string
} & ComponentProps<"h5">;

const H5 = ({
  children,
  color = "base",
  className = "",
  ...props
}: H5Props) => {
  return (
    <h5
      className={`${h5Theme.base} ${h5Theme.colors[color]} ${className}`}
      {...props}
    >
      {children}
    </h5>
  );
};

H5.displayName = "H5";

export { H5 };
export type { H5Props };
